import { FC, PropsWithChildren } from "react";
import { BaseProps } from "../../BaseProps";
import { getHtmlPropsFromBaseProps } from "../../utilities/getHtmlPropsFromBaseProps";
import styled from "styled-components";

/**
 * The `Shadow` component properties.
 */

export interface ShadowProps extends BaseProps {}

const ShadowDiv = styled.div`
  box-shadow: 0 0 0.25rem rgba(0, 0, 0, 0.08);
`;

/**
 * A simple container panel.
 */
export const Shadow: FC<PropsWithChildren<ShadowProps>> = (props) => {
  const { children } = props;

  const baseHtmlProps = getHtmlPropsFromBaseProps(props, {
    className: ["shadow"],
    testIdPrefix: "shadow",
  });

  return <ShadowDiv {...baseHtmlProps}>{children}</ShadowDiv>;
};
